import React from 'react';
import { TASK_TYPES } from '../../constants/taskTypes';

export { TASK_TYPES };

/**
 * Reusable task type select dropdown.
 * @param {Object} props
 * @param {string} props.value - Current selected value
 * @param {function} props.onChange - Called with (e) on change
 * @param {boolean} [props.includeAllOption] - If true, adds "All Types" option with empty value
 * @param {string[]} [props.options] - Optional custom options (e.g. subset from filter). Defaults to TASK_TYPES
 * @param {string[]} [props.includeOnlyTypes] - Optional types to show exclusively (e.g. ['Subtask'] when creating subtask)
 * @param {string[]} [props.excludeTypes] - Optional types to exclude (e.g. ['Subtask'] when creating task directly)
 * @param {string} [props.id] - Optional id for the select element
 * @param {string} [props.name] - Optional name for form submission
 * @param {string} [props.className] - Optional className
 * @param {Object} [props.style] - Optional inline styles
 * @param {boolean} [props.disabled] - If true, the select is disabled (e.g. when editing a Subtask)
 */
const TaskTypeSelect = ({
  value,
  onChange,
  includeAllOption = false,
  options = TASK_TYPES,
  includeOnlyTypes,
  excludeTypes = [],
  disabled = false,
  id,
  name,
  className,
  style
}) => {
  const filteredOptions = includeOnlyTypes?.length
    ? options.filter(type => includeOnlyTypes.includes(type))
    : excludeTypes.length
      ? options.filter(type => !excludeTypes.includes(type))
      : options;
  return (
    <select
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      className={className}
      style={style}
      disabled={disabled}
    >
      {includeAllOption && <option value="">All Types</option>}
      {filteredOptions.map(type => (
        <option key={type} value={type}>{type}</option>
      ))}
    </select>
  );
};

export default TaskTypeSelect;
